/*
 * IMPORTS
 */
import { gql } from "@apollo/client"; // NPM: Apollo client for handling graphql request.

/*
 * GRAPH
 */
const Index = gql`
  query MyQuery {
    AllCategory {
      message
      status
      name
      id
    }
  }
`;

/*
 * EXPORTS
 */
export default Index;
